module.exports = __webpack_public_path__ + "static/media/sort.3d8d943a.svg";